exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout-header-menu{position:absolute;right:0;top:0;height:100%}.layout-header-menu .user_info_cla{background-color:transparent;height:100%}.layout-header-menu .user_info_cla .submenu_cla{height:4.166667rem;color:#fff;background-color:transparent}.layout-header-menu .user_info_cla .submenu_cla .el-submenu__title{background-color:transparent;height:100%;color:#fff;line-height:4.166667rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60355be1","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":12}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/cdpBase/baseComponents/loginUserInfo/src/main.vue
// module id = C6Ly
// module chunks = 19